/*
=========================================================
* Material Kit 2 PRO React - v2.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 PRO React components
import SimpleBlogCard from "examples/Cards/BlogCards/SimpleBlogCard";

//images
import ICEMBAImage from "assets/images/ICEMBA-bg.jpg";
import treinamentoImage from "assets/images/treinamento.jpg";

function Produtos_Grade() {
  const callICEMBA = {
    type: "internal",
    route: "/pages/academia-ciber/icemba",
    color: "dark",
    label: "Saiba mais",
  };
  
  const callTreinamento = {
    type: "internal",
    route: "/pages/academia-ciber/treinamento",
    color: "dark",
    label: "Saiba mais",
  };

  return (
    <MKBox component="section" py={3}>
      <Container>
        <Grid
          container
          item
          flexDirection="column"
          alignItems="center"
          xs={12}
          lg={6}
          sx={{ textAlign: "center", mx: "auto" }}
        >
        <MKTypography variant="h2" mb={4}>
            Explore nossa Academia Cibernética{" "}
          </MKTypography>
          <MKTypography variant="body2" color="text">
            A Academia Cibernética oferece cursos de curta e longa durações de forma exclusiva, e assim como as nossas soluções são desenhados para atender
              às necessidades de nossos clientes.
          </MKTypography>
        </Grid>
        <Grid container spacing={2} sx={{ mt: 3 }} justifyContent={"center"}>
          <Grid item xs={12} md={6} lg={4}>
            <MKBox mt={3}>
              <SimpleBlogCard
                image={ICEMBAImage}
                title="ICEMBA"
                description="O centro de comunicações Templar é um dos mais avançados data centers para garantir a sua segurança cibernética."
                action={callICEMBA}
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <MKBox mt={3}>
              <SimpleBlogCard
                image={treinamentoImage}
                title="Treinamentos"
                description="Através de nossas parcerias nós somos capazes de facilitar a aquisição de licenças de software."
                action={callTreinamento}
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Produtos_Grade;
